import { render, staticRenderFns } from "./autoPaymentForPropety.vue?vue&type=template&id=6f6d819a&scoped=true"
import script from "./autoPaymentForPropety.vue?vue&type=script&lang=js"
export * from "./autoPaymentForPropety.vue?vue&type=script&lang=js"
import style0 from "./autoPaymentForPropety.vue?vue&type=style&index=0&id=6f6d819a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6d819a",
  null
  
)

export default component.exports